import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label", "title"]


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleCell',
  props: {
    title: null,
    data: null
  },
  setup(__props: any) {

// Accessible toggle for a DataTable `element` cell: a real <button> (keyboard-focusable + aria-label)
// whose click bubbles to the DataTable wrapper's @click, which opens the publish/deactivate confirm.
// It only reflects is_active (display) — it never mutates state; the confirm dialog does.


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    "aria-label": __props.title,
    title: __props.title,
    "data-testid": "daily-chest-publish-toggle",
    class: _normalizeClass(["relative inline-flex flex-shrink-0 h-6 w-11 p-0 border-2 border-transparent rounded-full transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-blue-500", __props.data.is_active ? 'bg-blue-500' : 'bg-gray-300'])
  }, [
    _createElementVNode("span", {
      "aria-hidden": "true",
      class: _normalizeClass(["pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200", __props.data.is_active ? 'translate-x-5' : 'translate-x-0'])
    }, null, 2)
  ], 10, _hoisted_1))
}
}

})